import { TaskWithUid, Task as ApiTask } from 'api/tasks';
import { Task as ITask } from 'data/tasks';
import { DocumentSkelton } from '../../api/document/types/document';
import { TaskSectionMeta } from './saga/tasks/id-name-map';

export enum PopupType {
  BalloonToolbar = 'BALLOON_TOOLBAR',
  LinkForm = 'LINK_FORM',
  TaskForm = 'TASK_FORM',
}
export enum TabNames {
  CommentsTab = 'comments',
  ConversationsTab = 'conversations',
  Tasks = 'tasks',
}
export enum EditorModes {
  Public = 'PUBLIC',
  Private = 'PRIVATE',
}

export interface SectionNameIdMap {
  parentDoc: number;
  content: string;
  resourceSectionType: ResourceSectionType.DocumentTask;
  resourceObjects: ITask[];
}

export interface DocTaskState {
  items: TaskWithUid[];
  documentRef: ContentTaskIdMap;
  activeTaskId: null | number;
  apiDone: boolean;
  loading: boolean;
  sectionNameIdMap: {
    [key: number]: SectionNameIdMap;
  };
}

export interface ActiveDocumentInfo {
  documentId: number | null;
  projectId: number | null;
  publicSection: {
    id?: number;
    type: EditorModes.Public;
  };
  privateSection: {
    id?: number;
    type: EditorModes.Private;
  };
}
export interface DocumentState {
  active: ActiveDocumentInfo;
  // balloonToolbar: BalloonToolbarDetails;
  // editor: {
  //   activeEditor: Editor | null;
  //   allEditors?: EditorsObject;
  // };
  // tabs: {
  //   activeTab: TabNames;
  // };
  tasks: DocTaskState;
  resourceSections: {
    items: (ResourceSection<Partial<ApiTask>> | TaskSectionMeta)[];
  };
  items: DocumentSkelton[];
}

export interface DocTask extends ApiTask {
  availableInDoc?: boolean;
}
export interface DocTaskProps {
  docId: number;
  projectId: number;
  activeTaskId: string;
}

export interface ContentTaskIdMap {
  [key: number]: {
    content: string;
    isActive: boolean;
    parentDocId: number;
  };
}

export enum ResourceSectionType {
  Milestone = 'MILESTONE',
  Task = 'TASK',
  Approval = 'APPROVAL',
  DocumentTask = 'DOCUMENT',
}

export enum DocumentResourceType {
  Default = 'DEFAULT',
  Highlight = 'HIGHLIGHT',
  Custom = 'CUSTOM',
}
export interface ResourceSection<T> {
  resourceSectionId: number;
  resourceSectionName?: string;
  resourceSectionType: ResourceSectionType;
  resourceIds: number[];
  resourceObjects?: T[];
  resourceType: DocumentResourceType;
}

export interface TaskSectionNameIdMap {
  [key: number]: SectionNameIdMap;
}

export type IDocTaskProps = JSX.IntrinsicAttributes &
  DocTaskProps & { children?: React.ReactNode };

export interface DocumentResourcePayload {
  projectID?: number;
  documentID?: number;
  documentSectionId?: number;
  sectionType: 'PUBLIC' | 'PRIVATE';
  resourceSections: (ResourceSection<Partial<ApiTask>> | TaskSectionMeta)[];
}
